export const File = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 61 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60 33.0679V69.1154C60 71.4717 59.0676 73.7316 57.4079 75.3978C55.7482 77.0639 53.4972 78 51.15 78H9.85C7.50283 78 5.2518 77.0639 3.59211 75.3978C1.93241 73.7316 1 71.4717 1 69.1154V9.88462C1 7.52827 1.93241 5.26843 3.59211 3.60224C5.2518 1.93606 7.50283 1 9.85 1H28.057C29.6213 1.00024 31.1214 1.62407 32.2276 2.73435L58.2724 28.881C59.3784 29.9916 59.9998 31.4976 60 33.0679Z"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M30.5 2.48047V24.692C30.5 26.2629 31.1216 27.7695 32.2281 28.8803C33.3345 29.991 34.8352 30.6151 36.4 30.6151H58.525"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 45.4229H45.25"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 60.2305H45.25"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
